module.exports = {
  title: `코딩과 투자`,
  description: `Blog posted about ...`,
  author: `용크셔`,
  introduction: `행함이 기적을 만든다`,
  siteUrl: `https://amkiwangblog.netlify.app`, // Your blog site url
  social: {
    twitter: ``, // Your Twitter account
    github: `https://github.com/garahad`, //
    medium: ``, // Your Medium account
    facebook: ``, // Your Facebook account
    linkedin: ``, // Your LinkedIn account
  },
  icon: `content/assets/felog.png`, // Add your favicon
  keywords: [`blog`],
  comment: {
    disqusShortName: '', // Your disqus-short-name. check disqus.com.
    utterances: 'garahad/new-gatsby-blog', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: '',
  },
  share: {
    facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: 'UA-169903705-1', // Add your google analytics tranking ID
};
